
import { Model } from './model';

export class PageModel implements Model {

  name: string;
  _id: string;
  pId: number;
  url: string;
  desc: string;
  webObjects: string[];

}
